var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.99 5.99023H4.40999L7.69999 2.70023C7.87999 2.52023 7.98999 2.27023 7.98999 1.99023C7.98999 1.44023 7.53999 0.990234 6.98999 0.990234C6.70999 0.990234 6.45999 1.10023 6.27999 1.28023L1.27999 6.28023C1.09999 6.47023 0.98999 6.72023 0.98999 6.99023C0.98999 7.26023 1.09999 7.52023 1.27999 7.70023L6.27999 12.7002C6.45999 12.8802 6.70999 12.9902 6.98999 12.9902C7.53999 12.9902 7.98999 12.5402 7.98999 11.9902C7.98999 11.7102 7.87999 11.4602 7.69999 11.2802L4.40999 7.99023H14C14.55 7.99023 15 7.54023 15 6.99023C15 6.44023 14.54 5.99023 13.99 5.99023Z",
    fill: "#47B881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d3606ebe.svg";
export { ForwardRef as ReactComponent };